import createValidationElementUtil from '../../../create-validation-element'
import { appMessages } from '../../../../../../messages'

function isInLengthValidatorUtil (params) {
  const {
    key,
    name,
    max,
    min,
    value
  } = params

  if (!value) {
    return createValidationElementUtil(key, appMessages.empty, { name })
  }

  if (value.length < min) {
    return createValidationElementUtil(key, appMessages.short, {
      name,
      min
    })
  }

  if (value.length > max) {
    return createValidationElementUtil(key, appMessages.long, {
      name,
      max
    })
  }

  return true
}

export default isInLengthValidatorUtil
